import React from 'react';
import PropTypes from 'prop-types';

const Option = ({ tag, name, icon, toQuestion, onAnswer, active = true }) => {
  return (
    <div
      className={`option tc-ns tl mh4-ns pointer cf grow-custom flex flex-column-ns flex-row mb4 ${!active && 'inactive-option'}`}
      onClick={() => { if(active) { onAnswer({ id: tag, toQuestion }) }}}
    >
      <div className="w4-ns h4-ns h3 w3 br-100 option-icon center-ns mb2 flex-none ">
        { icon && <img src={icon} alt={name} className="w-100"/> }
      </div>
      <p className="option-name fw5 f4 flex-auto ml0-ns ml3">{name}</p>
      { !active && <p className="option-subtitle f5">Coming soon</p>}
    </div>
  );
};

Option.propTypes = {
  tag: PropTypes.string,
  name: PropTypes.string,
  icon: PropTypes.string,
  toQuestion: PropTypes.number,
  onAnswer: PropTypes.func,
};

export default Option;



// WEBPACK FOOTER //
// ./src/components/option/Option.js